<template>
  <div id="app">
    <div style="display: flex;justify-content: center;">
      <el-row>
        <el-col :span="24" v-for="(item,index) in dataUrl" :key="index" style="display: flex;justify-content: center;">
          <img style="width:100%;height:100%" :src="item" :alt="item">
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      dataUrl: [],
      id: ''
    }
  },
  created() {
    let url = location.search;
    const dataList = url.slice(4)
    this.id = dataList
    this.APIRequest()
  },
  methods: {
    APIRequest() {
      // console.log(location);
      Axios({
        // 请求地址
        url: process.env.VUE_APP_TARGET_URL+`/api/system/sysProductSpecifications/detail?id=${this.id}`,
        // 请求类型
        method: 'get'
      }).then(res => {
        // console.log(res.data.data.picUrlList);
        this.dataUrl = res.data.data.picUrlList
      })

    }
  }
}
</script>

<style>
</style>

